/* Copyright(c) 2022 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/

/*
@author:Rutuja Jagtap task-3879
@Creation Date:20-07-2022
@Description:UI for (QADashboard) campaign specification
*/

import React,{ Component } from 'react'
import Navigation from '../layouts/navPage';
import Footer from '../layouts/footer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom'; 
import CampaignSpecificationQADashboardDetails from "./campaignSpecificationQADashboardDetails";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";
import { Badge } from 'antd';//Kiran Dhainje 5958- import badge for showing count of notes on notes icon
import '../publisher/publisherInternalReviewLead.css';

class CampaignSpecificationQADashboard extends Component{

    constructor() {
       
        super();
        this.state = {
              campID: '',
              parentCampID:'',
              reallocationID:'',
              advertiserID:'',
              campaignName:'',
              showNotesModal: false,//Kiran Dhainje 5958-added state for showNotesModal and below states for internal campaign notes
              campaignNotes: "",//Kiran Dhainje 5958-added state for campaignNotes which will be used to store the notes entered in textarea before sending to backend
              campaignNotesHistory: [],//Kiran Dhainje 5958-added state for campaignNotesHistory which will be used to store the notes history fetched from backend for a campaign
              editingNoteId: null,//Kiran Dhainje 5958-added state for editingNoteId which will be used to store the note id of note which is being edited currently
              editingNoteText: "",//Kiran Dhainje 5958-added state for editingNoteText which will be used to store the edited note text before saving it to backend
        }
        this.handleBackButtonToDashboard=  this.handleBackButtonToDashboard.bind(this);
        this.handleFileDownload = this.handleFileDownload.bind(this);
        this.handleFileShowDownload = this.handleFileShowDownload.bind(this);
        this.handlePDFFileShowDownload = this.handlePDFFileShowDownload.bind(this);
         this.openNotesModal = this.openNotesModal.bind(this);//Kiran Dhainje 5958-added this function to open notes modal and below models
        this.closeNotesModal = this.closeNotesModal.bind(this);//Kiran Dhainje 5958-added this function to close notes modal
        this.getCampaignNotes = this.getCampaignNotes.bind(this);//Kiran Dhainje 5958-added this function to get campaign notes
        this.handleNotesChange = this.handleNotesChange.bind(this);//Kiran Dhainje 5958-added this function to handle notes change in textarea
        this.handleSendNotes = this.handleSendNotes.bind(this);//Kiran Dhainje 5958-added this function to send notes to backend
        this.handleDeleteNote = this.handleDeleteNote.bind(this);//Kiran Dhainje 5958-added this function to delete note
        this.handleEditNote = this.handleEditNote.bind(this);//Kiran Dhainje 5958-added this function to edit note
        this.handleEditNoteSave = this.handleEditNoteSave.bind(this);//Kiran Dhainje 5958-added this function to save edited note
        this.notesPanelRef = React.createRef();//Kiran Dhainje 5958-added this ref for internal notes panel to handle auto scroll to notes after adding new note
        this.notesBodyRef = React.createRef();//Kiran Dhainje 5958-added this ref for internal notes body to handle auto scroll to notes after adding new note
        
    }

    componentDidMount() {  
      if(!this.props.auth.isAuthenticated) {
        this.props.history.push('/userLogin');
      }
      else{
        if(this.props.location.state!==undefined){
          var parsed = this.props.location.state;
          var campID=parsed.campID;
        }
        else if (sessionStorage.getItem("campID") !== undefined) {
           campID = sessionStorage.getItem("campID");
        } else {
          if (sessionStorage.getItem("parentCampID") === undefined) {
            sessionStorage.clear();
          }
        }

    
      fetch("campaign/CampaignDetails?campID=" + campID)
        .then((res) => res.json())
        .then((campaignDetails) => {
          this.setState(
            {
              campaignName: campaignDetails[0].campaignName,
              campID: campID,
            },
            () => {
              // Kiran Dhainje 5958 Fetch notes immediately after setting campID
              this.getCampaignNotes();
            },
          );
        })
        .catch(function (err) {
          console.log(err);
        });

    }
    }
    
    //Kiran-5958-Added helper methods for internal campaign notes
    computeInitials = (text = "") => {
      if (!text) return "";
      return text
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((segment) => segment.charAt(0).toUpperCase())
        .join("");
    };

    getUserDisplayDetails = () => {
      const authUser = (this.props.auth && this.props.auth.user) || {};
      const nameFromProfile = [authUser.firstName, authUser.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
      const fallbackName = authUser.userName || authUser.email || "Internal User";
      const displayName = nameFromProfile || fallbackName || "Internal User";
      return {
        name: displayName,
        initials: this.computeInitials(displayName),
      };
    };

    resolveNoteUserMeta = (note) => {
      const fallbackMeta = this.getUserDisplayDetails();
      if (!note) return fallbackMeta;
      const senderFullName = note.sender_full_name && note.sender_full_name.trim();
      const senderName = senderFullName || note.sender_name || note.userName || note.createdBy || note.ownerName;
      const sanitizedName = senderName && senderName.trim() ? senderName.trim() : fallbackMeta.name;
      const initials = note.userInitials || note.sender_initials || this.computeInitials(sanitizedName);
      return { name: sanitizedName, initials };
    };

    formatTimestamp = (value) => {
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return "Invalid Date";
      const diff = Date.now() - date.getTime();
      if (diff < 60000) return "Just now";
      if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
      const today = new Date();
      if (date.toDateString() === today.toDateString()) return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
      });
    };

    getTimestampLabel = (note) => {
      if (!note) return "";
      const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
      if (!rawTimestamp) return "";
      const formatted = this.formatTimestamp(rawTimestamp);
      if (note.Edited_attempt > 0) return `Edited ${formatted}`;
      return formatted;
    };

    getTimestampTitle = (note) => {
      if (!note) return "";
      const rawTimestamp = note.updated_at || note.created_at || note.timestampISO || note.timestamp || note.createdAt || note.date;
      if (!rawTimestamp) return "";
      const date = new Date(rawTimestamp);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    };

    //Kiran-5958-Added below code for internal campaign notes
    openNotesModal = () => {
      if (!this.state.campID || String(this.state.campID).trim() === "") {
        alert("Campaign ID is not available.");
        return;
      }

      const isOpening = !this.state.showNotesModal;
      this.setState(
        (prevState) => ({
          showNotesModal: !prevState.showNotesModal,
        }),
        () => {
          if (isOpening) {
            this.getCampaignNotes();
          }
        }
      );
    };

    closeNotesModal = () => {
      this.setState({ showNotesModal: false });
    };

    getCampaignNotes = async () => {
      const campID = String(this.state.campID).trim();
      if (!campID) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "fetch", campaign_id: campID }),
        });
        const data = await response.json();
        console.log("Notes response:", data);
        if (data.success) {
          this.setState({ campaignNotesHistory: data.result || [] });
        }
      } catch (err) {
        console.error("Error fetching notes:", err);
      }
    };

    handleNotesChange = (event) => {
      this.setState({ campaignNotes: event.target.value });
    };

    handleSendNotes = async () => {
      const { campaignNotes, campID } = this.state;
      if (!campaignNotes.trim()) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "add", campaign_id: campID, notes: campaignNotes }),
        });
        const result = await response.json();
        if (result.success) {
          this.setState({ campaignNotes: "" });
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error sending notes:", err);
      }
    };

    handleEditNote = (noteId, noteMessage = "") => {
      this.setState({ editingNoteId: noteId, editingNoteText: noteMessage });
    };

    handleEditNoteSave = async (noteId) => {
      const { editingNoteText, campID } = this.state;
      if (!editingNoteText.trim()) return;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "edit", note_id: noteId, campaign_id: campID, notes: editingNoteText }),
        });
        const result = await response.json();
        if (result.success) {
          this.setState({ editingNoteId: null, editingNoteText: "" });
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error editing note:", err);
      }
    };

    handleDeleteNote = async (noteId) => {
      const { campID } = this.state;
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "delete", note_id: noteId, campaign_id: campID }),
        });
        const result = await response.json();
        if (result.success) {
          this.getCampaignNotes();
        }
      } catch (err) {
        console.error("Error deleting note:", err);
      }
    };
    
    handleBackButtonToDashboard(e){
      //kiran-4752-removing console warning-added e.preventDefault();
      e.preventDefault();
      //Priyanka-5465-Changed page name
      //Kiran Dhainje 5866 Ref(5847)-DT-Campaign Progress back button navigating on wrong page
        if(this.props.auth.user.role === "LC" || this.props.auth.user.role === "LT"){
          this.props.history.push("/qualityDashboard",{advertiserID:this.state.advertiserID})//kiran-4630-navigate to proper page when click on back button
        } else {
          this.props.history.push("/qualityLeadsReview",{advertiserID:this.state.advertiserID})//kiran-4630-navigate to proper page when click on back button
        }
      }
    
    handleFileDownload(e) {
        var campID=this.state.campID;
         /**
       * @author rutuja jagtap
       * @param  Description handle the Campaign related Files
       * @return Description return All The File Download in Zip
       */
        
       fetch("agency/downloadDynamicPDFCampaignDetailsforAgency?campID=" + campID + "&campName="+this.state.campaignName ).then(r => r.blob())
          .then(downloadFiles =>
            this.setState({ downloadFiles: downloadFiles })
            )
            .then(this.handlePDFFileShowDownload);

          fetch("agency/downloadCampaignDetailsforAgency?campID=" + campID + "&campName="+encodeURIComponent(this.state.campaignName) ).then(r => r.blob()) //Rutuja task 5636 passing campaign name by doing ecodeURI
          .then(downloadFiles =>
            this.setState({ downloadFiles: downloadFiles })
            )
            .then(this.handleFileShowDownload);
        }/** End of handle File Download */

        handleFileShowDownload(blob){
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            let zipFileDownloadName=this.state.campID+'-'+this.state.campaignName+".zip";
          
            var newBlob = new Blob([this.state.downloadFiles], {type: "application/zip"})
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            } 
           
            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download=zipFileDownloadName;
            link.click();
          
          // ));
        }

        handlePDFFileShowDownload(blob){
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            let zipFileDownloadName=this.state.campID+'-'+this.state.campaignName+"-CampaignSpecification.pdf";
             var newBlob = new Blob([this.state.downloadFiles], {type: "application/pdf"})
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            } 
           
            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download=zipFileDownloadName;
            link.click();
          
          // ));
  
          }
           
           

    render()
    {
      if(this.props.location.state!==undefined ){
      // this.state.campID=this.props.location.state.campID;
      // this.state.parentCampID=this.props.location.state.parentCampID
      // this.state.reallocationID=this.props.location.state.reallocationID;
      this.setState({campID:this.props.location.state.campID,parentCampID:this.props.location.state.parentCampID,reallocationID:this.props.location.state.reallocationID})
      //kiran-4752-removing console warning-use setState
      }
      else if (sessionStorage.getItem("campID") !== undefined) {
        this.state.campID = sessionStorage.getItem("campID");
        this.state.parentCampID = sessionStorage.getItem("parentCampID");
        this.state.reallocationID = sessionStorage.getItem("reallocationID");//not use SetState-giving issue of page crash
      }
        return(
            <div>
           
           <Navigation/>
           {/* Nilesh-4839 Add display, flexDirection,flex, backgroundColor, paddingTop, position, top and zIndex in below div */}
           <div style={{paddingTop:'110px', display: "flex", flexDirection: "column"}}>

             <div class="container-fluid fixed-top" style={{
						flex: "0 0 auto",
						backgroundColor:"rgb(245 245 245)",
						paddingTop: "10px",
						position: "sticky",
						top: "79px",
						zIndex: "999"
					}}>
             <div class="row" style={{paddingBottom:'20px'}}>
             {/* kiran-4752-removing console warning-added "#/" */}
             <div class="col-lg-3 col-md-2 col-sm-3"><a href="#/"> <FaArrowAltCircleLeft size={32} style={{float:'left',color:'#056eb8'}} title="Back to Dashboard" onClick={this.handleBackButtonToDashboard} /></a></div>
            
              <div class="col-lg-6 col-md-8 col-sm-6" align="center">
                <label 
                       style={{                       
                        color: "#193D8F",
                        fontSize: "28px",                       
                        fontWeight:'500',
                        fontFamily:'roboto'}}>
                          Campaign ID:{this.state.campID}</label></div> 
             
              {/* Kiran-5958-Added internal notes modal */}
              {/* Kiran-6001-Ref(5958)-AC/DC/DT/ADV-Campaign Specs-Campaign Note icon alignment issue */}
             <div className="col-lg-3 col-md-2 col-sm-3 d-flex justify-content-end align-items-center gap-2">

                  <Badge
                    count={
                      this.state.campaignNotesHistory.length > 10
                        ? "10+"
                        : this.state.campaignNotesHistory.length
                    }
                    overflowCount={10}
                    offset={[0, -9]}
                  >
                    <img
                      src="notes.png"
                      alt="Notes"
                      title="View Internal Campaign Notes"
                      style={{ width: '30px', height: '32px', cursor: 'pointer',marginBottom:'23px' }}
                      onClick={this.openNotesModal}
                    />
                  </Badge>

                  <button
                    type="button"
                    className="btn add-button"
                    id="cmd"
                    onClick={this.handleFileDownload}
                  >
                    Download
                  </button>

                </div>
                </div>
           </div>
              <CampaignSpecificationQADashboardDetails  greeting={this.state.campID}/> 
          
                
                 

              </div>
           {/* Kiran-5958-Added internal notes modal */}
                       {this.state.showNotesModal && (
              <div ref={this.notesPanelRef} className="internal-notes-wrapper">
                <div className="internal-notes-panel">
                  <button
                    type="button"
                    className="internal-notes-close"
                    onClick={this.closeNotesModal}
                    aria-label="Close internal campaign notes"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="internal-notes-title">
                    <div className="internal-notes-heading">
                      Internal Campaign Notes
                    </div>
                    <div className="internal-notes-subtitle">
                      Campaign ID : <span>{this.state.campID || "--"}</span>
                    </div>
                  </div>
                  <div className="internal-notes-body" ref={this.notesBodyRef}>
                    {this.state.campaignNotesHistory.length > 0 ? (
                      this.state.campaignNotesHistory
                        .slice()
                        .reverse()
                        .map((note) => {
                          const { name, initials } = this.resolveNoteUserMeta(note);
                          const timestampLabel = this.getTimestampLabel(note);
                          const timestampTitle = this.getTimestampTitle(note);
                          const isJustNow = timestampLabel === "Just now";
                          const isEdited = note.Edited_attempt > 0;
                          return (
                            <div className="internal-note-item" key={note.note_id || note.id || note.created_at}>
                              <div className="internal-note-avatar">{initials}</div>
                              <div className="internal-note-content">
                                <div className="internal-note-header">
                                  <div className="internal-note-meta">
                                    <span className="internal-note-user">{name}</span>
                                    <span
                                      className={`internal-note-time ${isJustNow ? "internal-note-time-new" : ""} ${isEdited ? "internal-note-time-edited" : ""}`}
                                      title={timestampTitle}
                                    >
                                      {timestampLabel}
                                      {isEdited }
                                    </span>
                                  </div>
                                </div>
                                <div className="internal-note-message">{note.message}</div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <div className="internal-notes-empty">
                        <p>No notes yet.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
           <Footer/>
            </div>
        )
    }
};

/**
       * @author Rutuja Jagtap
       * @param  Description handle the login authentication
       * @return Description return All details of authentication
       */
 CampaignSpecificationQADashboard.propTypes = {
        logoutUser: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired
    }
    
    const mapStateToProps = (state) => ({
        auth: state.auth
    })
export default  connect(mapStateToProps, { logoutUser })(withRouter(CampaignSpecificationQADashboard)); 
